import { render, staticRenderFns } from "./EditaProdutos.vue?vue&type=template&id=363f57c2&"
import script from "./EditaProdutos.vue?vue&type=script&lang=js&"
export * from "./EditaProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports